var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRaconl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 345,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2371,
    y: 175,
    width: 388,
    height: 345
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2371 -175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2473.71 440.385 2493.11 214.808 2636.32 214.808 2656.29 440.385 2473.71 440.385ZM2724.77 440.385 2690.53 440.385 2669.99 198.885C2668.85 185.615 2659.15 175 2647.17 175L2482.83 175C2470.85 175 2461.15 185.615 2460.01 198.885L2439.47 440.385 2405.23 440.385 2405.23 480.193 2371 480.193 2371 520 2759 520 2759 480.193 2724.77 480.193 2724.77 440.385Z",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaconl);
export default __webpack_public_path__ + "static/media/RACONL.9159fec7e9fa4cb3f2baecd3767e513e.svg";
export { ForwardRef as ReactComponent };